import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { useDateFnsLocale } from '@/hooks'
import { useDatePickerProps } from './useDatePickerProps'

type RecurrenceEndCalendarProps = {
  date: uui.domain.YYYYMMDD
}

export function RecurrenceEndCalendar(props: RecurrenceEndCalendarProps) {
  const { date } = props
  const datePickerProps = useDatePickerProps(date)
  const locale = useDateFnsLocale()

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
      <DatePicker {...datePickerProps} />
    </LocalizationProvider>
  )
}
